export enum EmojiType {
  Transparent = "transparent",
  Active = "active",
}
